import { render, staticRenderFns } from "./AbaTempoContribuicao.vue?vue&type=template&id=219956c8"
import script from "./AbaTempoContribuicao.vue?vue&type=script&lang=ts"
export * from "./AbaTempoContribuicao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports